import React from "react";
import userLayouts from "../../../../constants/userLayoutsConsts";
import { routes } from "../../../../constants";
import { Navigate, Route } from "react-router-dom";
import { baseRouteMaker } from "../../../../constants/routeConsts";
import {
  Dashboard,
  OfferForm,
  OfferList,
  PackageForm,
  PackageList,
  Request,
  ServicesForm,
  ServicesList,
  StaffForm,
  StaffList,
  UpdateBankAccount,
  WalletInfo,
  WalletTransactions,
  CustomerInfo,
  Subscriptions,
  SubscriptionsPlanHistory,
  ActivePlan,
  GiftCard,
  PurchaseGiftCard,
  SendPushNotification,
  SentPushNotificationList,
  ServiceProviderReviewInfo,
  HelpAndSupport,
} from "../../../../component/pages/service-provider-admin";
import {
  AddonPlan,
  AddonsAndSponsorships,
} from "../../../../component/pages/super-admin";
import { UserPermissions } from "../../../../component/pages/service-provider-admin/modules/user-permissions";
import {
  CustomerInfoAppointmentDetails,
  CustomerInfoAppointmentViewDetails,
  CustomerInfoDetails,
  CustomerInfoDetailsDetails,
} from "../../../../component/pages/service-provider-admin/modules/customer-db/customer-info";
import { ServiceProviderReviewInfoDetails } from "../../../../component/pages/service-provider-admin/modules/service-provider-reviews";
import {
  AddOrganizationSponsorshipHistory,
  AddPushNotificationHistory,
} from "../../../../component/pages/super-admin/modules/addons-and-sponsorships";
import GiftCardTransactions from "../../../../component/pages/service-provider-admin/modules/wallet/gift-card/GiftCardTransactions";

const renderServiceProviderAdminProtectedRoutes = ({ layout }) => {
  switch (layout) {
    case userLayouts.IS_AUTH:
      return (
        <>
          <Route
            path={routes.UPDATE_BANK_ACCOUNT}
            element={<UpdateBankAccount />}
          />
        </>
      );

    case userLayouts.IS_MAIN:
      return (
        <>
          {/* <Route path="/" element={<Navigate to={baseRouteMaker(routes.DASHBOARD)} />}/> */}

          {/* Dashboard module routes */}
          <Route path={routes.DASHBOARD} element={<Dashboard />} />

          {/* HelpAndSupport module routes */}
          <Route
            path={routes.HELP_AND_SUPPORT}
            element={
              <Navigate
                to={baseRouteMaker(routes.HELP_AND_SUPPORT_LIST)}
                replace
              />
            }
          />
          <Route
            path={routes.HELP_AND_SUPPORT_LIST}
            element={<HelpAndSupport />}
          />

          {/* Services module routes */}
          <Route path={routes.SERVICES} element={<ServicesList />} />
          <Route path={routes.CREATE_SERVICE} element={<ServicesForm />} />

          {/* Staff module routes */}
          <Route path={routes.STAFF} element={<StaffList />} />
          <Route path={routes.CREATE_STAFF} element={<StaffForm />} />

          {/* Offers and packages module routes */}
          <Route
            path={routes.OFFERS_AND_PACKAGES}
            element={<Navigate to={baseRouteMaker(routes.OFFER)} replace />}
          />

          {/* Offer module routes */}
          <Route path={routes.OFFER} element={<OfferList />} />
          <Route path={routes.CREATE_OFFER} element={<OfferForm />} />

          {/* Packages module routes */}
          <Route path={routes.PACKAGES} element={<PackageList />} />
          <Route path={routes.CREATE_PACKAGE} element={<PackageForm />} />

          {/* Request module routes */}
          <Route path={routes.REQUEST} element={<Request />} />

          {/* Wallet module routes */}
          <Route
            path={routes.WALLET}
            element={
              <Navigate to={baseRouteMaker(routes.WALLET_INFO)} replace />
            }
          />
          <Route path={routes.WALLET_INFO} element={<WalletInfo />} />
          <Route path={routes.GIFT_CARD} element={<GiftCard />} />
          <Route
            path={routes.PURCHASE_GIFT_CARD}
            element={<PurchaseGiftCard />}
          />
          <Route
            path={routes.WALLET_TRANSACTION}
            element={<WalletTransactions />}
          />
          <Route
            path={routes.GIFT_CARD_TRANSACTIONS}
            element={<GiftCardTransactions />}
          />

          {/* Customer DB module routes */}
          <Route
            path={routes.SERVICE_PROVIDER_CUSTOMER_DB}
            element={
              <Navigate
                to={baseRouteMaker(routes.SERVICE_PROVIDER_CUSTOMER_INFO)}
                replace
              />
            }
          />

          <Route
            path={routes.SERVICE_PROVIDER_CUSTOMER_INFO}
            element={<CustomerInfo />}
          />
          <Route
            path={routes.SERVICE_PROVIDER_CUSTOMER_INFO_DETAILS}
            element={<CustomerInfoDetails />}
          >
            <Route
              path={routes.SERVICE_PROVIDER_CUSTOMER_INFO_DETAILS_DETAILS}
              element={<CustomerInfoDetailsDetails />}
            />
              <Route path={routes.SERVICE_PROVIDER_CUSTOMER_INFO_DETAILS_APPOINTMENTS} element={<CustomerInfoAppointmentDetails />}/>
          </Route>
          <Route path={routes.SERVICE_PROVIDER_CUSTOMER_INFO_DETAILS_APPOINTMENTS_VIEW} element={<CustomerInfoAppointmentViewDetails />}/>

          {/* Customer DB module routes */}
          <Route
            path={routes.PUSH_NOTIFICATION}
            element={
              <Navigate
                to={baseRouteMaker(routes.SEND_PUSH_NOTIFICATION)}
                replace
              />
            }
          />
          <Route
            path={routes.SEND_PUSH_NOTIFICATION}
            element={<SendPushNotification />}
          />
          <Route
            path={routes.SENT_PUSH_NOTIFICATION_LIST}
            element={<SentPushNotificationList />}
          />

          {/* Subscriptions and addons */}
          <Route
            path={routes.SUBSCRIPTIONS_AND_ADDONS}
            element={
              <Navigate
                to={baseRouteMaker(routes.SERVICE_PROVIDER_SUBSCRIPTIONS)}
                replace
              />
            }
          />
          <Route
            path={routes.SERVICE_PROVIDER_SUBSCRIPTIONS}
            element={<Subscriptions />}
          />
          <Route
            path={routes.SERVICE_PROVIDER_SUBSCRIPTIONS_PLAN_HISTORY}
            element={<SubscriptionsPlanHistory />}
          />
          <Route
            path={routes.SERVICE_PROVIDER_SUBSCRIPTIONS_ACTIVE_PLAN}
            element={<ActivePlan />}
          />

          {/* Addons and sponsorships */}
          <Route
            path={routes.ADDONS_AND_SPONSORSHIPS}
            element={
              <Navigate
                to={baseRouteMaker(routes.ADDONS_AND_SPONSORSHIPS_ADDON)}
                replace
              />
            }
          />
          <Route
            path={routes.ADDONS_AND_SPONSORSHIPS_ADDON}
            element={<AddonsAndSponsorships />}
          />
          <Route
            path={routes.ADDONS_AND_SPONSORSHIPS_ADDON_PLAN_HISTORY}
            element={<AddonPlan />}
          />
          <Route
            path={
              routes.ADDONS_AND_SPONSORSHIPS_ORGANIZATION_SPONSORSHIP_HISTORY
            }
            element={<AddOrganizationSponsorshipHistory />}
          />
          <Route
            path={routes.ADDONS_AND_SPONSORSHIPS_PUSH_NOTIFICATION_HISTORY}
            element={<AddPushNotificationHistory />}
          />
          <Route path={routes.USER_PERMISSIONS} element={<UserPermissions />} />
        </>
      );

    default:
      return;
  }
};

export default renderServiceProviderAdminProtectedRoutes;
